// extracted by mini-css-extract-plugin
export default {"modalWrapper":"personalInfo_modalWrapper__VtMXU","titleWrapper":"personalInfo_titleWrapper__7Rsy0"};